import ModelPortfolio from "./ModelPortfolio.jsx";

export default ModelPortfolio;



// WEBPACK FOOTER //
// ./src/components/pages/Create_portfolio_by_Advisor/model_portfolio/index.js